/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import Axios from 'axios';
import router from '@/router';
import { authService } from '@/services';

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'en',
  },
});

axios.interceptors.request.use(
  (config) => {
    const isAuthorized = authService.isAuthorized();
    if (isAuthorized) {
      const token = authService.getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      const classroomId = localStorage.getItem('classroom_id') || null;
      if (classroomId) {
        config.headers.classroom_id = classroomId;
      }
      const lang = localStorage.getItem('language') || null;
      if (lang) {
        config.headers['Accept-Language'] = lang;
      }
    }
    return config;
  },
  error => Promise.reject(error),
);

axios.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        authService.logout();
        router.push({
          name: 'Login',
        });
        return;
      }
    }
    return Promise.reject(error);
  },
);

export default axios;
